import { render, staticRenderFns } from "./EmailLoginRredirect.vue?vue&type=template&id=1ae56336"
import script from "./EmailLoginRredirect.vue?vue&type=script&lang=js"
export * from "./EmailLoginRredirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports